import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import useSidebarStyles from "../../../utils/SidebarStyles";
import defaultSpaceColors from "../../../collections/defaultSpaceColors";

import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

import tinycolor from "tinycolor2";

import isSpaceThemed from "../../../utils/IsSpaceThemed";

import { createStyles, Box, Text, Group } from "@mantine/core";

const useStyles = createStyles((theme, { colors, settingsView }) => ({
  spaceNameWrap: {
    padding: "0px 0px 0px 20px",
    display: "flex",
    flexFlow: "row",
    justifyContent: "space-between",
    boxSizing: "border-box",
    alignItems: "center",
    cursor: "pointer",
    minHeight: 47,
    // color: colors.sidebar_text_color,
    // color: !settingsView ? colors.sidebar_text_color : defaultSpaceColors.sidebar_text_color,
    // color: !settingsView && isSpaceThemed(colors) ? colors.sidebar_text_color : theme.colors.gray[7],
    flexWrap: "nowrap",

    "&:hover": {
      backgroundColor: !settingsView
        ? tinycolor(colors.sidebar_background_color).darken(4).toString()
        : tinycolor(defaultSpaceColors.sidebar_background_color)
            .lighten(4)
            .toString(),
    },
  },
  spaceNameClose: {
    color: "#fff",
    fontWeight: 600,
    padding: "5px 8px",
    borderRadius: 5,
    "&:hover": {
      backgroundColor: tinycolor(colors.primary_button_background_color)
        .darken(15)
        .toString(),
    },
  },
  nodeIconWrap: {
    display: "inline-block",
    width: "20px",
    textAlign: "center",
  },
  nodeItemLink: {
    display: "inline-block",
    width: "100%",
    paddingTop: "11px",
    paddingBottom: "11px",
    textDecoration: "none",
    // marginLeft: "5px",
    fontWeight: 400,
    // color: colors.sidebar_text_color,
    // color: !settingsView ? colors.sidebar_text_color : defaultSpaceColors.sidebar_text_color,
    color:
      !settingsView && isSpaceThemed(colors)
        ? colors.sidebar_text_color
        : theme.colors.gray[7],

    "&:hover": {
      textDecoration: "none",
    },
  },
  textStyle: {
    color:
      !settingsView && isSpaceThemed(colors)
        ? colors.sidebar_text_color
        : "#000",
  },
}));

export default function MembersNode(props) {
  const location = useLocation();

  const space = useSelector((state) => state.space);
  const colors = useSelector((state) => state.colors);
  const user = useSelector((state) => state.user);
  const { t, i18n } = useTranslation();
  const { settingsView } = useSidebarStyles();
  const { classes, cx } = useStyles({ colors, settingsView });
  const navigate = useNavigate();

  const getLinkPath = () => {
    return `/space/${props.slug}/members`;
  };

  if (!space.slug) {
    return null;
  }

  return (
    <Box className={classes.spaceNameWrap}>
      <Link
        className={classes.nodeItemLink}
        to={getLinkPath(props.slug, props.version)}
      >
        <Group spacing={10}>
          <Box className={classes.nodeIconWrap}>
            <FontAwesomeIcon icon={solid("users")} />
          </Box>
          <Text className={classes.textStyle}>
            {t("spaces.sidebar.membersNode.member")}
          </Text>
        </Group>
      </Link>
    </Box>
  );
}
